// extracted by mini-css-extract-plugin
export default {"Left":"SectionHeader_Left__vQ8zI","Right":"SectionHeader_Right__d1vJL"};